module.exports = __webpack_public_path__ + "img/wuyou_xiangqing.efd50b33.png";